/*
 * Bobby Rubber Stamp — scroll-reveal.
 *
 * Card grids (collection + product) ease in as they enter the viewport.
 * Everything else in the motion layer is pure CSS (see custom-motion.css);
 * this is the one piece that needs GSAP/ScrollTrigger, loaded from a CDN in
 * theme.liquid ahead of this file. Degrades to "no reveal, cards just show"
 * if the CDN is blocked or the visitor prefers reduced motion.
 */
(function () {
  if (window.__bobbyMotionInit) return;
  window.__bobbyMotionInit = true;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initScrollReveal() {
    if (prefersReducedMotion) return;
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    gsap.registerPlugin(ScrollTrigger);

    ScrollTrigger.batch('.collection-card, .product-card', {
      start: 'top 88%',
      once: true,
      onEnter: function (batch) {
        gsap.from(batch, {
          opacity: 0,
          y: 16,
          duration: 0.5,
          ease: 'power2.out',
          stagger: 0.06,
        });
      },
    });
  }

  function boot() {
    initScrollReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
  });
})();
